module.exports = __webpack_public_path__ + "img/15.18f39f6c.png";